import {showNotify} from 'vant';
// 成功通知封装
export const showSuccessNotify = (message, duration = 2000) => {
    showNotify({
        type: 'success',
        message,
        duration,
    });
};

// 错误通知封装
export const showDangerNotify = (message, duration = 2000) => {
    showNotify({
        type: 'danger',
        message,
        duration,
    });
};

// 警告通知封装
export const showWarningNotify = (message, duration = 2000) => {
    showNotify({
        type: 'warning',
        message,
        duration,
    });
};
